<template>
  <div>
    <!-- 入口挂件 -->
    <entrance
      v-if="entranceVisible"
      :entrance-img="entranceImg"
      @click="clickEntrance"
    />
    <modal append-to-body class="plv-iar-modal--topic" v-if="visible">
      <div class="plv-iar-topic"  v-click-out-side="closeModal">
        <topic-content :topic-data="topicData" @choose-answer="chooseAnswer"/>
      </div>
    </modal>
  </div>
</template>

<script>
import Entrance from '@/components/topic/entrance';
import TopicContent from '@/components/topic/TopicContent';
import modal from '@/components/common/modal/MobileModal';
import ClickOutSide from '@/assets/utils/click-out-side';
import mixin from './mixin';

export default {
  name: 'MobileTopic',
  mixins: [mixin],
  components: { TopicContent, modal, Entrance },
  directives: { ClickOutSide },
};
</script>

<style lang="scss">
.plv-iar-modal--topic {
  z-index: 20;
}
.plv-iar-topic {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 20;
  background: url(./imgs/bg.png) 100% 100%;
  background-size: 100% 100%;
  padding: 28px 24px;
}

</style>
